import { render, staticRenderFns } from "./Prenotazioni.vue?vue&type=template&id=2b473fca&"
import script from "./Prenotazioni.vue?vue&type=script&lang=js&"
export * from "./Prenotazioni.vue?vue&type=script&lang=js&"
import style0 from "./Prenotazioni.vue?vue&type=style&index=0&id=2b473fca&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports